<select style="height: 36px" #select [value]="selectedState" (change)="selectedStateChanged(select.value)">
  <option *ngFor="let state of states" [value]="state.id">{{ state.name }}</option>
</select>
